import type { FlyUIEnvironment, TopBannerConfig } from "@wayflyer/flyui";
import { IconInfoCircle16Line } from "@wayflyer/flyui-icons/16/line";

export const isStorybook = () => typeof window !== "undefined" && (window as any).DOCS_OPTIONS;

const PRODUCTION_HOST = "app.wayflyer.com";

const isProductionHost = () => typeof window !== "undefined" && window.location.host === PRODUCTION_HOST;

/**
 * The `environment` prop for `FlyUIProvider`: a critical "Production" tag shown to staff
 * on the production host, and nothing anywhere else. Pass `isStaff` from the app's user
 * context; the staff app can pass `true`, as every user there is staff.
 */
export const getFlyUIEnvironment = ({ isStaff }: { isStaff: boolean }): FlyUIEnvironment | undefined =>
  isStaff && isProductionHost() ? { label: "Production", status: "critical" } : undefined;

/**
 * `topBanners` entries for `NavigationProvider` warning that the app isn't running on the
 * production host. Empty on the production host, so callers can spread the result straight
 * into their own `topBanners` array regardless of environment. Pass the same `id` across
 * callers that share dismissal state (e.g. two shells of the same app).
 */
export const getDevelopmentEnvironmentTopBanners = ({ id }: { id: string }): TopBannerConfig[] =>
  isProductionHost()
    ? []
    : [
        {
          id,
          message: "DEVELOPMENT ENVIRONMENT",
          icon: IconInfoCircle16Line,
          color: "warning",
          size: "large",
          enableDismissForSession: true,
          matchRoutes: ["*"],
        },
      ];
